/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type CustomerPickupTimeFragment = {
  __typename: 'Cart'
  id: number | null
  delayedPickupAt: any | null
  pickupTimeSelected: boolean
}

export const CustomerPickupTimeFragment = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'customerPickupTimeFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Cart' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delayedPickupAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pickupTimeSelected' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode
